"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = _default;

var _reactGlobalConfiguration = _interopRequireDefault(require("react-global-configuration")),
    _queryString = _interopRequireDefault(require("query-string")),
    IFRAME_ID = "download_iframe";

function _default(queryParams) {
  var serviceEndpoint = _reactGlobalConfiguration["default"].get("serviceEndpoint"),
      downloadUrl = "".concat(serviceEndpoint, "export/downloads?").concat(_queryString["default"].stringify(queryParams, {
    arrayFormat: "comma"
  })),
      iframeElement = document.getElementById(IFRAME_ID);

  if (iframeElement) return void (iframeElement.src = downloadUrl);
  var newIframe = document.createElement("iframe");
  newIframe.setAttribute("id", IFRAME_ID), newIframe.setAttribute("style", "display:none"), document.body.appendChild(newIframe);
  var appendedIframe = document.getElementById(IFRAME_ID);
  appendedIframe && (appendedIframe.src = downloadUrl);
}